export default "__VITE_ASSET__LnFDnXcj__"